import { render, staticRenderFns } from "./volumeEde.vue?vue&type=template&id=01fc2287&scoped=true&"
import script from "./volumeEde.vue?vue&type=script&lang=js&"
export * from "./volumeEde.vue?vue&type=script&lang=js&"
import style0 from "./volumeEde.vue?vue&type=style&index=0&id=01fc2287&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fc2287",
  null
  
)

export default component.exports